

const React = require("react");
require("./typography/Inter/index.pc");
require("./typography/MintGrotesk/index.pc");
require("./typography/OldschoolGrotesk/index.pc");

exports.classNames = {
  "ease-in": "_pub-11f16876_ease-in ease-in",
  "flex": "_pub-11f16876_flex flex",
  "flex-break": "_pub-11f16876_flex-break flex-break",
  "nowrap": "_pub-11f16876_nowrap nowrap",
  "reset": "_pub-11f16876_reset reset",
  "text-body-caption": "_pub-11f16876_text-body-caption text-body-caption",
  "text-body-paragraph-m": "_pub-11f16876_text-body-paragraph-m text-body-paragraph-m",
  "text-body-paragraph-s": "_pub-11f16876_text-body-paragraph-s text-body-paragraph-s",
  "text-heading-heading-large": "_pub-11f16876_text-heading-heading-large text-heading-heading-large",
  "text-heading-heading-medium": "_pub-11f16876_text-heading-heading-medium text-heading-heading-medium",
  "text-heading-heading-small": "_pub-11f16876_text-heading-heading-small text-heading-heading-small",
  "text-heading-title-large": "_pub-11f16876_text-heading-title-large text-heading-title-large",
  "text-heading-title-medium": "_pub-11f16876_text-heading-title-medium text-heading-title-medium",
  "text-heading-title-small": "_pub-11f16876_text-heading-title-small text-heading-title-small",
  "text-ui-large": "_pub-11f16876_text-ui-large text-ui-large",
  "text-ui-large-heavy": "_pub-11f16876_text-ui-large-heavy text-ui-large-heavy",
  "text-ui-small": "_pub-11f16876_text-ui-small text-ui-small",
  "text-ui-small-heavy": "_pub-11f16876_text-ui-small-heavy text-ui-small-heavy",
  "text-ui-tiny": "_pub-11f16876_text-ui-tiny text-ui-tiny",
  "z-index-menu": "_pub-11f16876_z-index-menu z-index-menu",
};

const getDefault = (module) => module.default || module;

const addClass = (className, properties) => ({
  ...properties,
  className: properties.className ? properties.className + " " + className : className,
});

const castStyle = (value) => {
  const tov = typeof value;
  if (tov === "object" || tov !== "string") return value;
  return value.trim().split(";").reduce((obj, keyValue) => {
    const [key, value] = keyValue.split(":");
    if (!value || value === "undefined") return obj;
    const trimmedValue = value.trim();
    if (trimmedValue === "undefined") return obj;
    obj[key.trim()] = value && value.trim();
    return obj;
  }, {});
};

const getClassName = (className) => {
  return className ? className.split(" ").map(part => (
    "_11f16876_" + part + " " +"_pub-11f16876_" + part + " " +part
  )).join(" ") : "";
};

const ColorPreview = React.memo(React.forwardRef(function ColorPreview(props, ref) {
  return React.createElement("div", {
      "ref": ref,
      "key": "cd18549a",
      "className": "_cd18549a _11f16876 _pub-11f16876 " + "_11f16876_text-ui-large-heavy _pub-11f16876_text-ui-large-heavy text-ui-large-heavy",
    },
    React.createElement("div", {
        className: "_d785724f _11f16876 _pub-11f16876", 
        "key": "d785724f",
        "style": castStyle("background:" + (props.value)),
      },
    
    ),
    React.createElement("h3", {
        className: "_4e8c23f5 _11f16876 _pub-11f16876", 
        "key": "4e8c23f5",
      },
      (props.value)
    )
  );
}));

